import styled from 'styled-components';
import theme from 'styles/theme';

export const Banner = styled.div`
  padding: 10px 14px;
  border: 1px solid ${theme.colors.darkYellow2};
  background: ${theme.colors.whiteYellow};
  border-radius: 4px;
  color: ${theme.colors.textBlack};
  font-size: 13px;
`;

export const Title = styled.strong`
  display: block;
  margin-bottom: 4px;
`;

export const Body = styled.div``;
